import React from 'react';
import PropTypes from 'prop-types';
import TagList from 'components/Tags/TagList';
import TypeAhead from '../TypeAhead';
import styles from './styles.module.scss';

import SubMarketNeighborhoodListItem from './SubMarketNeighborhoodListItem';

const LocationSelector = ({
  subMarkets,
  onNeighborhoodChange,
  onSubmarketChange,
  selectedNeighborhoods,
  allNeighborhoods,
  selectedSubmarkets,
}) => {
  const onNeighborhoodCheck = (checked, neighborhood, submarket) => {
    onNeighborhoodChange(neighborhood, checked, submarket);
  };

  const allUnselectedNeighborhoods = allNeighborhoods.filter(
    (nhood) =>
      !selectedNeighborhoods.some(
        ({ externalId }) => nhood.externalId === externalId
      )
  );

  return (
    <div>
      <TypeAhead
        predictableItems={allUnselectedNeighborhoods}
        onItemClick={(item) =>
          onNeighborhoodChange(item, !selectedNeighborhoods.includes(item))
        }
      />
      <TagList
        tags={selectedNeighborhoods}
        displayKey="name"
        className={styles.tagList}
        onRemove={(id) => {
          const nhoodToRemove = selectedNeighborhoods.find(
            (nhood) => nhood.id === id
          );
          if (nhoodToRemove)
            onNeighborhoodChange(
              nhoodToRemove,
              false, // always unchecked from this control
              nhoodToRemove.submarkets[0]
            );
        }}
      />
      <div data-qa="sub-market-neighborhood-list">
        {subMarkets.map((subMarket) => (
          <SubMarketNeighborhoodListItem
            key={subMarket.id}
            subMarket={subMarket}
            onSubMarketChange={onSubmarketChange}
            onNeighborhoodCheck={onNeighborhoodCheck}
            selectedNeighborhoods={selectedNeighborhoods}
            isChecked={
              !!selectedSubmarkets.find(
                (sm) => sm.externalId === subMarket.externalId
              )
            }
          />
        ))}
      </div>
    </div>
  );
};

LocationSelector.propTypes = {
  subMarkets: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      name: PropTypes.string,
    })
  ).isRequired,
  onSubmarketChange: PropTypes.func.isRequired,
  onNeighborhoodChange: PropTypes.func.isRequired,
  selectedNeighborhoods: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      name: PropTypes.string,
      geojson: PropTypes.shape({}),
      yearlyPricePerFoot: PropTypes.number,
      parameterizedName: PropTypes.string,
    })
  ).isRequired,
  allNeighborhoods: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      name: PropTypes.string,
      geojson: PropTypes.shape({}),
      yearlyPricePerFoot: PropTypes.number,
      parameterizedName: PropTypes.string,
    })
  ).isRequired,
  selectedSubmarkets: PropTypes.arrayOf(
    PropTypes.shape({
      externalId: PropTypes.string,
    })
  ).isRequired,
};
LocationSelector.defaultProps = {};
export default LocationSelector;
